import { render, staticRenderFns } from "./NmicToken.vue?vue&type=template&id=12211a91&scoped=true&"
import script from "./NmicToken.vue?vue&type=script&lang=js&"
export * from "./NmicToken.vue?vue&type=script&lang=js&"
import style0 from "./NmicToken.vue?vue&type=style&index=0&id=12211a91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12211a91",
  null
  
)

export default component.exports